import {DEFAULT_DISPLAY_PAGES, DISPLAY_PAGES_TYPE} from '@functions/const/widgetDisplay';
import isMobileDevice from '@assets/helpers/utils/isMobileDevice';
import {DISPLAY_DEVICES} from '@functions/const/widgetDisplay';

/**
 * Check current page and device to display the widget
 * @param {App.WidgetSetting} settings
 * @returns {boolean}
 */
export default function canShowWidget(settings) {
  const {displayPages = DEFAULT_DISPLAY_PAGES, displayDevices = DISPLAY_DEVICES.ALL} = settings;
  return isCurrentPageAllowed(displayPages) && isCurrentDeviceAllowed(displayDevices);
}

/**
 * @param displayPages
 * @returns {boolean}
 */
const isCurrentPageAllowed = displayPages => {
  const {type, values = []} = displayPages;

  // check page type & path
  const isPageMatch = (() => {
    if (type === DISPLAY_PAGES_TYPE.ALL) return true;
    const {page_type: pageType, path} = window.AVADA_APP_FAQS_REQUEST;
    if (!pageType && !path) return false;

    const pageTypes = values.map(x => x.page_type?.split(',')).flat();
    // console.log(pageTypes, pageType);
    if (pageTypes.includes(pageType)) return true;

    // const {root = '/'} = window.Shopify?.routes || {};
    // const prefix = root === '/' ? '' : root.slice(0, -1);
    const customPages = values.filter(x => x.page_type === 'custom').map(x => x.path);
    // console.log(customPages, path);
    return customPages.includes(path);
  })();

  switch (type) {
    case DISPLAY_PAGES_TYPE.ALL:
      return true;
    case DISPLAY_PAGES_TYPE.SHOW_SPECIFIC:
      return isPageMatch;
    case DISPLAY_PAGES_TYPE.HIDE_SPECIFIC:
      return !isPageMatch;
    default:
      return false;
  }
};

const isCurrentDeviceAllowed = displayDevices => {
  return !(isMobileDevice()
    ? displayDevices === DISPLAY_DEVICES.DESKTOP
    : displayDevices === DISPLAY_DEVICES.MOBILE);
};
